import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import { fetchTransactions } from "../../features/transaction/transactionSlice";
import Transaction from "./Transaction";

export default function Transactions({ setUrlCheck }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const match = useMatch("/");
    const [radioSearchType, setRadioSearchType] = useState("");
    const [searchText, setSearchText] = useState("");

    
    const { transactions, isLoading, isError } = useSelector(
        (state) => state.transaction
        );
    const [allTransactions, setAllTransactions] = useState(transactions);

    useEffect(() => {
        dispatch(fetchTransactions());
    }, [dispatch]);

    useEffect(() => {
        setAllTransactions(transactions);
    }, [transactions]);

    const handleTransactions = () => {
        navigate("/trackers");
    };

    useEffect(() => {
        if(radioSearchType && searchText) {
            const updatedTransactions = transactions?.filter(trans => trans.type === radioSearchType)?.filter(trans => trans.name.toLowerCase().includes(searchText.toLowerCase()));;
            setAllTransactions(updatedTransactions);
        } else if (radioSearchType) {
            const updatedTransactions = transactions?.filter(trans => trans.type === radioSearchType);
            console.log("radio ", radioSearchType, updatedTransactions);
            setAllTransactions(updatedTransactions);
        } else if(searchText) {
            const updatedTransactions = transactions?.filter(trans => trans.name.toLowerCase().includes(searchText.toLowerCase()));;
            setAllTransactions(updatedTransactions);
        } else if (radioSearchType === ""){
            setAllTransactions(transactions);
        } else {
            setAllTransactions([]);
        }
    }, [searchText, radioSearchType]);

    // decide what to render
    let content = null;
    let buttonContent = null;
    let radioSearch = null;
    if (isLoading) content = <p>Loading...</p>;

    if (!isLoading && isError)
        content = <p className="error">There was an error occured</p>;

    if (!isLoading && !isError && match && transactions?.length > 0) {
        content = [...transactions]?.sort((a,b) => parseInt(b?.id) - parseInt(a?.id))?.slice(0,5)?.map((transaction) => (
            <Transaction key={transaction.id} transaction={transaction} setUrlCheck = {setUrlCheck} />
        ));
    }

    if (!isLoading && !isError && !match && transactions?.length > 0) {
        content = [...allTransactions]?.sort((a,b) => parseInt(b?.id) - parseInt(a?.id))?.map((transaction) => (
            <Transaction key={transaction.id} transaction={transaction} setUrlCheck = {setUrlCheck} />
        ));
    }

    if (!isLoading && !isError && transactions?.length === 0) {
        content = <p>No transactions found!</p>;
    }

    if(!isLoading && !isError && match && transactions?.length > 5) {
        buttonContent =   <button className="btn" style = {{ width: "20%" }} onClick = {handleTransactions}>
                            View All
                          </button>;
    }

    if (!isLoading && !isError && !match && transactions?.length > 0) {
        radioSearch = <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <label for = "income" style={{ marginRight: 5 }}>
                    <input style={{ marginRight: 2 }} type = "radio" value = {radioSearchType} name = "radioSearch" onClick={() => setRadioSearchType("income")} />    
                     Income
                </label>
                <label for = "expense" style={{ marginRight: 5 }}>
                    <input style={{ marginRight: 2 }} type = "radio" value = {radioSearchType} name = "radioSearch" onClick={() => setRadioSearchType("expense")} /> 
                    Expense
                </label>
                <label for = "all" style={{ marginRight: 5 }}>
                    <input style={{ marginRight: 2 }} type = "radio" value = {radioSearchType} name = "radioSearch" onClick={() => setRadioSearchType("")} /> 
                    All
                </label>
            </div>
            <div style = {{ marginTop: 10 }}>
                <input type = "text" placeholder="Search" value = {searchText} onChange={(e) => setSearchText(e.target.value)} />
            </div>
        </div>;
    }




    return (
        <>
            <p className="second_heading">Your Transactions:</p>

            {radioSearch}
            <div className="conatiner_of_list_of_transactions">
                <ul>{content}</ul>
            </div>
            {buttonContent}
        </>
    );
}
